import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import { number } from "../../../config/index";
import { convertToTimeZone, formatReminderTimeInTimeZone, formatTime, getCombinedReminderUtcDate } from "../../../helper/common";
import ReminderMenu from "../../TaskSidebar/TaskSidebarContent/Comments/ReminderMenu";
import DynamicReminderPopup from "./DynamicReminderPopup";
import { ReminderContext } from "./ReminderContextProvider";
import ReminderList from "./ReminderList";
import ReminderPopup from "./ReminderPopup";
import "./reminder.scss";
import { useDynamicReminderPopup, useReminderList } from "./taskRemindersHook";

/**
 * Handles the condition to open ReminderPopup or reminder List
 * @author Shivam Mishra
 */

const HandleReminder = ({ isNew, onClick, show, anchor, setShowReminder }) => {
  const { showCustomPopup, isAddClicked, setIsAddClicked, displayWarning, isReminderClicked, editRem, editName, editDate, editTime, isDynamic, setIsReminderClicked } = useContext(ReminderContext);
  const { reminders } = useSelector((state) => state.reminders);
  const { contentManagerDetailsData } = useSelector((state) => state.contentManager);
  const { task } = useSelector((state) => state.taskSidebar);
  const anchorAlign = { horizontal: "left", vertical: task.taskId ? "top" : "bottom" };
  const popupAlign = { horizontal: "right", vertical: task.taskId ? "middle" : "top" };
  const [showAddReminderMenu, setShowAddReminderMenu] = useState(false);
  const addMenuFooterRef = useRef(null);
  const addMenuIconRef = useRef(null);

  const handleOutSideClick = () => {
    setShowReminder(false);
  };

  useEffect(() => {
    if (!show) setShowAddReminderMenu(false);
  }, [show]);

  useOnClickOutside(addMenuFooterRef, () => {
    setShowAddReminderMenu((open) => (open ? false : open));
  });

  const { popupBodyContent, handleSaveReminder, closeCustomPopup } = useDynamicReminderPopup({ setShowReminder: setShowReminder, reminderType: number.ONE });
  const { handleClick, delReminder, setDelReminder, handleAddRem } = useReminderList(handleOutSideClick);

  const onAddReminderClick = () => {
    if (task.taskId) {
      setShowAddReminderMenu((v) => !v);
    } else {
      handleAddRem(true);
    }
  };

  const setAddMenuFooterRef = (el) => {
    addMenuFooterRef.current = el;
  };

  const setAddMenuIconRef = (el) => {
    addMenuIconRef.current = el;
  };

  /**
   *  closes the reminder popup
   *  @author: Sarthak Arora
   */

  const handleCancel = () => {
    setShowReminder(false);
    setIsAddClicked(false);
    setShowAddReminderMenu(false);
  };

  const reminderDetails = (reminder) => {
    const combinedReminderUtc = getCombinedReminderUtcDate(reminder?.ReminderDate, reminder?.ReminderTime);
    const reminderDateStr = combinedReminderUtc ? convertToTimeZone(combinedReminderUtc, "dd MMM yy") : (reminder?.ReminderDate ? convertToTimeZone(reminder.ReminderDate, "dd MMM yy") : "");
    const reminderTimeStr = formatReminderTimeInTimeZone(reminder?.ReminderDate, reminder?.ReminderTime, "hh:mm aa") ?? (reminder?.ReminderTime ? formatTime(reminder.ReminderTime, "hh:mm aa") : "");
    return (
      <div className='small text-secondary'>
        {reminderTimeStr} , {reminderDateStr}
      </div>
    );
  };

  return (
    <>
      {!isNew && (isAddClicked || (task.taskId ? task.reminderCount === number.ZERO : !contentManagerDetailsData?.hasReminder)) ? (
        <DynamicReminderPopup
          popupAnchor={anchor}
          show={show}
          setShowReminder={setShowReminder}
          popupBodyContent={popupBodyContent}
          handleCancel={handleCancel}
          handleSaveReminder={handleSaveReminder}
          showCustomPopup={showCustomPopup}
          closeCustomPopup={closeCustomPopup}
          extraWidth={true}
          skipButtons={true}
          anchorAlign={anchorAlign}
          popupAlign={popupAlign}
        />
      ) : (
        <ReminderList
          onClick={onClick}
          show={show}
          anchor={anchor}
          reminders={reminders}
          handleClick={handleClick}
          delReminder={delReminder}
          setDelReminder={setDelReminder}
          onAddReminderClick={onAddReminderClick}
          addMenuFooterRef={setAddMenuFooterRef}
          addMenuIconRef={setAddMenuIconRef}
          isAddMenuOpen={showAddReminderMenu}
          handleOutSideClick={handleOutSideClick}
          reminderDetails={reminderDetails}
        />
      )}
      {showAddReminderMenu && task.taskId && (
        <ReminderMenu
          isTaskReminder
          setShowDrop={setShowReminder}
          setShowRemindMenu={setShowAddReminderMenu}
          setShowCustomPopup={(open) => open && setIsAddClicked(true)}
          keepParentOpenOnCustom
          comment=''
          anchor={addMenuIconRef}
          popupClassName='dt-popup reminder-menu-popup task-bell-reminder-menu text-left'
          menuAnchorAlign={{ horizontal: "right", vertical: "bottom" }}
          menuPopupAlign={{ horizontal: "left", vertical: "bottom" }}
          appendTo={addMenuFooterRef.current}
        />
      )}
      {isReminderClicked && (
        <ReminderPopup
          onClick={onClick}
          ReminderId={editRem}
          TaskId={task.taskId}
          Name={editRem ? editName : task.Name}
          reminderDate={editDate}
          reminderTime={editTime}
          handleAddRem={handleAddRem}
          popupAnchor={anchor}
          show={show}
          disable={isDynamic}
          setIsReminderClicked={setIsReminderClicked}
          setShowReminder={setShowReminder}
        />
      )}
    </>
  );
};
export default HandleReminder;
